import { OptionConfig } from "../../types/project";
import { SET_OPTION_CONFIG } from "./actionTypes";

export const setOptionConfig = (option: OptionConfig | null) => {
  return {
    type: SET_OPTION_CONFIG,
    payload: option,
  };
};
